// Событие с расписанием переходит из запланированных в текущие с начала дня
// первой гонки (по местному времени), а не с момента ее старта.
// true — старт приходится на завтра или позже
export const startsAfterToday = (date) => {
  const startOfTomorrow = new Date();
  startOfTomorrow.setHours(24, 0, 0, 0);

  return new Date(date) >= startOfTomorrow;
};
